<template>
  <div class="fixed top-0 left-1/2 z-30 bg-rose-500">
    <div class="relative h-4 px-1">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        class="absolute top-0 -left-4 size-4 rotate-90 text-rose-500"
        viewBox="0 0 100 100"
      >
        <polygon points="0,0 100,0 0,100" fill="currentColor" />
      </svg>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1em"
        height="1em"
        class="absolute top-0 -right-4 size-4 text-rose-500"
        viewBox="0 0 100 100"
      >
        <polygon points="0,0 100,0 0,100" fill="currentColor" />
      </svg>
      <div class="flex h-full flex-row items-center justify-center">
        <SvgoPikaWarning class="mr-1 size-2.5 text-rose-900" />
        <p class="text-xxs font-bold text-rose-900 uppercase">
          {{ $t("billing.missing_payment_banner") }}
        </p>
      </div>
    </div>
  </div>
</template>
